import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LearnMoreLink from '../../career-path/utility/LearnMoreLink';
import Favorite from '../../utility/Favorite';
import SunIcon from '../../utility/SunIcon.jsx';

export class RelatedCareersCard extends React.Component {
  _isMounted = false;

  secondaryFill = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  primaryFill = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  get secondaryBorderBottom() {
    return {
      borderBottom: `5px solid ${this.props.tenant.secondary}`,
      minWidth: this.props.cardWidth,
      marginRight: this.props.cardMargin,
    };
  }

  get hiddenBox() {
    return {
      visibility: 'hidden',
    };
  }

  primaryColor = {
    color: `${this.props.tenant.primary}`,
  };

  render() {
    return (
      <div
        className="related-careers-card"
        // The custom carousel has a fade at the end
        // We need to add hidden boxes in order to leave room
        // to view the last career outside of the fade
        style={
          this.props.careerId ? this.secondaryBorderBottom : this.hiddenBox
        }
      >
        <div className="related-careers-card__image-box">
          <img
            className="related-careers-card__image"
            src={this.props.photoUrl}
            alt={`Related career: ${this.props.title}`}
          />
          <div className="career-card-favorite-container">
            <Favorite
              careerId={this.props.careerId}
              careerName={this.props.title}
              career={this.props.career}
            />
          </div>
        </div>
        <div className="related-careers-card__content">
          <div className="related-careers-card__title">{this.props.title}</div>
          <div className="related-careers-card__link-container">
            <Link
              to={{
                search: `career=${encodeURIComponent(this.props.title)}`,
              }}
              aria-label={`Learn more about ${this.props.title} career`}
            >
              <LearnMoreLink
                tenant={this.props.tenant}
                data-cy="learn-more-link"
                primary={this.props.tenant.primary}
                component={this.props.title}
                modalImage={this.props.photoUrl}
                ariaLabel={`Learn more about ${this.props.title} career`}
              />
            </Link>
            {this.props.careerOutlook && (
              <SunIcon
                additionalClassName="related-careers__bright-outlook"
                setParentOnClick={this.props.setBrightOutlookModal}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  return { tenant };
};

export default connect(mapStateToProps)(RelatedCareersCard);
